import {CasinoLegacyDeepLinkActionBase} from '../casino-legacy-deep-link-action-base';

export class TerminateDeepLinkAction extends CasinoLegacyDeepLinkActionBase {
  execute(): Promise<void> {
    return Promise.resolve();
  }
}
